export enum EEmitenteDocumentoFiscal {
  EmissaoPropria = 1,
  EmissaoTerceiro = 2,
}
